// import { EMP_ATTENDANCE } from "../action_types";
const initialstate = {
  departments: null,
  skillSetWithDepartment: null,
  skills: null,
  groupsWithSkills: null,
  searchByDeptName: "",
  searchByDeptId: "", 
};
export const skillMatrix = (state = initialstate, { type, payload }) => {
  switch (type) {
    case "GET_DEPARTMENTS": {
      return {
        ...state,
        departments: payload,
      };
    }
    case "GET_GROUPS": {
      return {
        ...state,
        groups: payload,
      };
    }
    case "GET_Skill_Set_With_Department": {
      return {
        ...state,
        skillSetWithDepartment: payload,
      };
    }
    case "GET_SKILLS": {
      return {
        ...state,
        skills: payload,
      };
    }
    case "GET_GROUPS_WITH_SKILLS": {
      return {
        ...state,
        groupsWithSkills: payload,
      };
    }
    case "SET_SEARCH_DEPT_NAME": {
      return {
        ...state,
        searchByDeptName: payload,
      };
    }
    case "SET_SEARCH_DEPT_ID": {
      return {
        ...state,
        searchByDeptId: payload,
      };
    }
    default: {
      return { ...state };
    }
  }
};
